import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';
import { withPixelLineHeight } from '../../../../base/styles/functions.web';
// eslint-disable-next-line lines-around-comment
// @ts-ignore
import { getDialInfoPageURL, hasMultipleNumbers } from '../../../functions';
import DialInNumber from './DialInNumber';
const useStyles = makeStyles()(theme => {
    return {
        container: {
            '& .info-label': Object.assign({}, withPixelLineHeight(theme.typography.bodyLongBold))
        },
        link: Object.assign(Object.assign({}, withPixelLineHeight(theme.typography.bodyLongRegular)), { color: theme.palette.link01, '&:hover': {
                color: theme.palette.link01Hover
            } })
    };
});
/**
 * Returns a ReactElement for showing how to dial into the conference, if
 * dialing in is available.
 *
 * @private
 * @returns {null|ReactElement}
 */
function DialInSection({ phoneNumber, dtmfPiN, }) {
    const { classes, cx } = useStyles();
    const conferenceID = useSelector((state) => state['features/invite'].conferenceID);
    const dialInfoPageUrl = useSelector(getDialInfoPageURL);
    const showMoreNumbers = useSelector((state) => hasMultipleNumbers(state['features/invite'].numbers));
    const { t } = useTranslation();
    return (React.createElement("div", { className: classes.container },
        React.createElement(DialInNumber, { dtmfPiN: dtmfPiN !== null && dtmfPiN !== void 0 ? dtmfPiN : '', conferenceID: conferenceID !== null && conferenceID !== void 0 ? conferenceID : '', phoneNumber: phoneNumber }),
        showMoreNumbers ? React.createElement("a", { className: cx('more-numbers', classes.link), href: dialInfoPageUrl, rel: 'noopener noreferrer', target: '_blank' }, t('info.moreNumbers')) : null));
}
export default DialInSection;
